import React from "react"

import {SchedulerEvent, SchedulerEventPublishRecognitionVisibility, ScheduledRecognitionSource} from "@irati/types"
import Flex from "@irati/ui/src/Flex"
import Source from "../Source"
import Visibility from "../Visibility"

type Props = {
  center?: boolean
  recognition: SchedulerEvent
}

const {MicrosoftTeams, Perkbox} = ScheduledRecognitionSource

const Details: React.FC<Props> = ({recognition, center}) => {
  const isPrivate = recognition.payload?.publishRecognition?.visibility === SchedulerEventPublishRecognitionVisibility.Private
  if (!isPrivate && recognition.payload?.publishRecognition?.source === Perkbox) {
    return null
  }

  return (
    <Flex alignItems="center" justifyContent={center ? "center" : "flex-start"}>
      {isPrivate && <Visibility />}
      {!isPrivate && recognition.payload?.publishRecognition?.source === MicrosoftTeams && <Source />}
    </Flex>
  )
}

export default Details
